import React, {useEffect} from 'react';
import {Root, Routes, useSiteData} from 'react-static';
import {Router} from '@reach/router';

const queryString = require('query-string');

import {PhaseProvider, usePhaseDispatch, usePhaseState} from './funnel-schedule/phase-context';
import {UserProvider, useUserState, useUserDispatch} from './contexts/user';
import OptinModal from 'components/OptinModal';
import {ModalProvider} from 'contexts/modal';
import 'styles/app.scss';
import axios from 'axios';
import {DateTime} from 'luxon';

//Due to a limitation of dotenv we must use three seperate statements
const {SCHEDULE_URL} = process.env;
const {SF_API_URL} = process.env;
const {SITE_ID} = process.env;

function AppWrapper({children}) {
  const phaseDispatch = usePhaseDispatch();
  const userDispatch = useUserDispatch();
  const {registrationId} = useUserState();
  useEffect(() => {
    axios.get(SCHEDULE_URL).then(({headers, data}) => {
      const resTime = headers.date && Date.parse(headers.date);
      const currentTime = resTime || new Date();
      if (typeof window !== 'undefined') {
        const qs = queryString.parse(window.location.search);
        if (qs.phase) {
          data.default = {...data.default, phase: qs.phase};
        }
        if (qs.pid || qs.orid) {
          let affPhaseData;
          if (qs.pid) {
            const pid = window.atob(qs.pid);
            const [startTime, endTime] = pid.split('_').map((v) => parseInt(v) * 1000);
            if (!(isNaN(new Date(endTime)) || isNaN(new Date(startTime)))) {
              affPhaseData = {
                phase: currentTime < endTime ? 'during' : 'after',
                startTime,
                endTime
              };
            }
          }
          data.special = {...(qs.orid ? {orid: qs.orid} : {}), ...affPhaseData};
        }
      }
      return phaseDispatch({
        type: 'SET_PHASE',
        payload: data
      });
    });
  }, []);
  useEffect(() => {
    registrationId
      ? axios
          .get(`${SF_API_URL}/site/${SITE_ID}/state/`, {
            params: {
              registrationId,
              t: new Date().getTime()
            }
          })
          .then(({data}) => {
            if (!data.webinar) {
              data.webinar = {
                phase: 'after',
                time: Math.floor(DateTime.utc().minus({days: 5}).toSeconds())
              };
            }
            const {firedEvents = []} = data.webinar;

            phaseDispatch({
              type: 'SET_PHASE',
              payload: data
            });
            firedEvents.map((e) => userDispatch({type: 'ADD_EVENT', payload: e}));
            phaseDispatch({type: 'USER_STATE_LOADED'});
          })
      : phaseDispatch({type: 'USER_STATE_LOADED'});
  }, [registrationId]);
  return children;
}

const App = () => {
  const {phaseData} = useSiteData();
  return (
    <Root>
      <UserProvider>
        <PhaseProvider value={phaseData}>
          <ModalProvider>
            <AppWrapper>
              <Router className="frn-content d-flex align-items-stretch flex-column">
                <Routes default />
              </Router>
            </AppWrapper>
          </ModalProvider>
        </PhaseProvider>
      </UserProvider>
    </Root>
  );
};

export default App;
